module.exports = __webpack_public_path__ + "img/2.5dbe8a68.png";